import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { tap } from 'rxjs/operators';

import { Page } from '../models/page.model';
import { MessageService } from './message.service';
import { Role } from '../models/role.model';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';


@Injectable({
  providedIn: 'root'
})
export class RoleService {

  private readonly baseUrl = `${environment.http.apiRoot}/roles`;

  readonly defaultSort = [{paramName: 'descr', sortDirection: 'ASC'}];

  constructor(private http: HttpClient, private messageService: MessageService) { }

  getRole(roleId: number): Observable<Role> {
    return this.http.get<Role>(`${this.baseUrl}/${roleId}`);
  }

  getRoleList(params: HttpParams): Observable<Page<Role>> {
    return this.http.get<Page<Role>>(`${this.baseUrl}`, {params});
  }

  createRole(createRoleRequest) {
    return this.http.post<any>(`${this.baseUrl}`, createRoleRequest).pipe(
      tap(res => this.messageService.handleSuccess('ROLES.MESSAGES.CREATE.SUCCESS'))
    );
  }

  updateRole(roleId: number, createRoleRequest): Observable<Role> {
    return this.http.put<any>(`${this.baseUrl}/${roleId}`, createRoleRequest).pipe(
      tap(res => this.messageService.handleSuccess('ROLES.MESSAGES.UPDATE.SUCCESS'))
    );
  }

  deleteRole(roleId: number): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/${roleId}`).pipe(
      tap(res => this.messageService.handleSuccess('ROLES.MESSAGES.DELETE.SUCCESS'))
    );
  }
}
